export const clientpoolId = process.env.REACT_APP_USERPOOL_ID;
export const clientpoolClientId = process.env.REACT_APP_CLIENT_ID;
